import { HttpAgent } from '@icp-sdk/core/agent'
import { setConfig } from '@plug-core/appConfig'
import { keychainManager } from '@plug-core/keyring'
import { useConnectionProvider } from '@plug-core/state'
import { getAgentFactory } from '@plug-core/utils/getAgentFactory'
import { getOisyAgent } from '@utils/oisy'
import { getPlugExtension } from '@utils/plugExtension'

const getAgent = getAgentFactory(async (principal) => {
  try {
    return await keychainManager.getIdentity(principal)
  } catch (e) {
    if ((e as Error).message === 'Delegation has expired, please re-authenticate') {
      keychainManager.clearVault()
      useConnectionProvider.setState({ provider: null })
    }

    throw e
  }
})

setConfig('getAgent', (options) => {
  const { provider } = useConnectionProvider.getState()

  if (!options?.principalId) {
    return getAgent(options)
  }

  const plug = getPlugExtension()
  if (provider === 'plug' && plug?.agent) {
    return plug.agent as unknown as HttpAgent
  }

  const oisyAgent = getOisyAgent()
  if (provider === 'oisy' && oisyAgent) {
    return oisyAgent as unknown as HttpAgent
  }

  return getAgent(options)
})
